module.exports = __webpack_public_path__ + "media/images/zender_logo-be5c352daea5afd35755250ddba0b93c.png";